export const FETCH_USER_DETAILS = "FETCH_USER_DETAILS";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const GET_CXO_TOKEN = "GET_CXO_TOKEN";
export const SET_CXO_TOKEN = "SET_CXO_TOKEN";
